export default __webpack_public_path__ + "static/media/Jeremy.51ef2df0.jpg";